import { Configuration, ApiApi } from "@jobindsats/typescript-fetch-jobindsats";

class JobindsatsApi {
    private api: ApiApi;
    constructor() {
        const con = new Configuration(
            {
                basePath: window.location.origin,
            })
        this.api = new ApiApi(con)
    }

    public getApi() {
        return this.api;
    }
}

const jobindsatsApi = new JobindsatsApi();
export default jobindsatsApi;